import selectComponent from 'utilities/select-component'
import MultistepForm from 'component/MultistepForm'

export default class AutoflameCaclulator {

    constructor(element) {
        this.$component = selectComponent(element)
        this.$form = this.$component.elements.calculatorForm;

        if (this.$component.find('[data-msf-trigger="0"]')) {
            this.initMultistepForm()
        } else {
            this.isMultistepForm = false
        }

        this.initCalculator()
    }

    initMultistepForm = () => {
        this.isMultistepForm = true
        this.multistepForm = new MultistepForm(this.$component)
    }

    initCalculator = () => {
        this.$form.on('submit', this.handleSubmit)
    }

    handleSubmit = (e) => {
        e.preventDefault()
        this.hideErrorMessages()

        if (! this.validate()) {
            return
        }

        let fuelSpent = 0;
        if (this.$component.elements.horsepower.val() != '') {
            fuelSpent = this.calculateHorsepowerFuelSpent()
        } else if (this.$component.elements.lbsPerHour.val() != '') {
            fuelSpent = this.calculateLbsFuelSpent()
        }

        this.$component.elements.fuelSpentOutput.text('$' + this.formatMoney(fuelSpent))
        this.$component.elements.fuelSavingsOutput.text('$' + this.formatMoney(fuelSpent * .08))

        this.setValuesOfContactForm();

        if (this.isMultistepForm) {
            this.multistepForm.onSubmit(0)
        }
    }

    setValuesOfContactForm()
    {
        $('#processed-horsepower').val(this.$component.elements.horsepower.val());
        $('#processed-lbs-per-hour').val(this.$component.elements.lbsPerHour.val());
        $('#processed-hours').val(this.$component.elements.hours.val());
        $('#processed-therm-cost').val(this.$component.elements.decathermCost.val());
        $('#processed-percent-utilization').val(this.$component.elements.percentUtilization.val());
        $('#processed-fuel-spent').val(this.$component.elements.fuelSpentOutput.text());
        $('#processed-fuel-savings').val(this.$component.elements.fuelSavingsOutput.text());

    }

    calculateHorsepowerFuelSpent = () => {
        return this.$component.elements.horsepower.val()
            * 0.425
            * (this.$component.elements.percentUtilization.val() / 100)
            * (this.$component.elements.hours.val() / 10)
            * this.$component.elements.decathermCost.val()
    }

    calculateLbsFuelSpent = () => {
        return (this.$component.elements.lbsPerHour.val() / 34.5)
            * 0.425
            * (this.$component.elements.percentUtilization.val() / 100)
            * (this.$component.elements.hours.val() / 10)
            * this.$component.elements.decathermCost.val()
    }

    validate = () => {
        let valid = true;

        if (!this.validateOptionalFields()) {
            valid = false;
            this.displayOptionalFieldsErrorMessage();
        }

        if (!this.validateRequiredFields()) {
            valid = false;
            this.displayRequiredFieldsErrorMessage();
        }

        return valid;
    }

    validateOptionalFields = () => {
        // if they don't provide either, then we're not valid
        if ((isNaN(this.$component.elements.horsepower.val()) || this.$component.elements.horsepower.val() == '')
            && (isNaN(this.$component.elements.lbsPerHour.val()) || this.$component.elements.lbsPerHour.val() == '')
        ){
            return false;
        }

        // if they provide both, then we're not valid
        if ((!isNaN(this.$component.elements.horsepower.val()) && this.$component.elements.horsepower.val() !== '')
            && (!isNaN(this.$component.elements.lbsPerHour.val()) && this.$component.elements.lbsPerHour.val() !== '')
        ){
            return false;
        }

        // they have provided one or the other.
        return true;
    }

    validateRequiredFields = () => {
        if (isNaN(this.$component.elements.hours.val())
            || this.$component.elements.hours.val() == ''
            || isNaN(this.$component.elements.decathermCost.val())
            || this.$component.elements.decathermCost.val() == ''
            || isNaN(this.$component.elements.percentUtilization.val())
            || this.$component.elements.percentUtilization.val() == ''
        ) {
            return false
        }

        return true
    }

    displayOptionalFieldsErrorMessage = () => {
        this.$component.elements.optionalFieldError.show()
    }

    displayRequiredFieldsErrorMessage = () => {
        this.$component.elements.requiredFieldError.show()
    }

    hideErrorMessages = () => {
        this.$component.elements.optionalFieldError.hide()
        this.$component.elements.requiredFieldError.hide()
    }

    /*
     * SHAMELESSLY STOLEN
     * https://stackoverflow.com/questions/149055/how-can-i-format-numbers-as-currency-string-in-javascript
     */
    formatMoney = (amount, decimalCount = 2, decimal = ".", thousands = ",") => {
        decimalCount = Math.abs(decimalCount)
        decimalCount = isNaN(decimalCount) ? 2 : decimalCount

        const negativeSign = amount < 0 ? "-" : ""

        let i = parseInt(amount = Math.abs(Number(amount) || 0).toFixed(decimalCount)).toString()
        let j = (i.length > 3) ? i.length % 3 : 0

        return negativeSign
            + (j ? i.substr(0, j) + thousands : '')
            + i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + thousands)
            + (decimalCount ? decimal + Math.abs(amount - i).toFixed(decimalCount).slice(2) : "")
      }
}